// extracted by mini-css-extract-plugin
export default {"root":"KhPH_dT5nv1wUNhEHf3k","wrap":"UaeKwsjypJoaBUYWU_Zn","header":"elm14Rt4pLmnLmzPbVlO","title":"teXJ4ehz5RjoVg950mVn"};